export default __webpack_public_path__ + "static/media/1.6a84b567.png";